import React from "react";
import { Col, Row, Button, Card } from "react-bootstrap";
import { MdDone, MdError } from "react-icons/md";
import { useParams } from "react-router-dom";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import Kargah from "../Images/kargah.png";

export default () => {
  const { workshop_id, status } = useParams();
  const page_meta = {
    language: "fa",
    copyright: "پژوهیار",
    description: "نرم‌افزار استناددهی",
    title: "پرداخت | کارگاه",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "پژوهیار",
      },
    },
  };
  const body = `به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر گرفته شده است. برای
      درخواست کارگاه و کلاس آموزشی از طریق فرم تربیت‌مدرس، فرم سازمانی و فرم عمومی ثبت نام فرمایید.`;

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner body={body} image={Kargah} header_color="#E5E1DA" />
      <Row className="justify-content-center pt-5 pb-5">
        <Col md={7}>
          <Row>
            <Card>
              <Card.Body>
                <Row className="justify-content-center">
                  {status === "success" ? (
                    <>
                      <MdDone />
                      <p>پرداخت با موفقیت انجام شد.</p>
                    </>
                  ) : status === "failed" ? (
                    <>
                      {" "}
                      <MdError />
                      <p>پرداخت با مشکل مواجه شد !</p>
                    </>
                  ) : (
                    ""
                  )}
                </Row>
                <hr />
                <Row className="pt-2 justify-content-center">
                  <Button
                    variant="success"
                    href={`/workshop/register/detail/${workshop_id}/${status}`}>
                    مشاهده جزییات
                  </Button>
                </Row>
              </Card.Body>
            </Card>
          </Row>
        </Col>
      </Row>
    </DocumentMeta>
  );
};
